"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _Dropdown = _interopRequireDefault(require("../Dropdown.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var cx = _bind["default"].bind(_Dropdown["default"]);

var Header = function Header(_ref) {
  var content = _ref.content;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: cx('dropdown__header')
  }, content);
};

Header.displayName = 'Header';
Header.propTypes = {
  /** Content of the header */
  content: _propTypes["default"].node.isRequired
};
var _default = Header;
exports["default"] = _default;